import methods from '@/enums/methods';
import ThothV2 from '../base/thothV2';

class InstallmentsService extends ThothV2 {
    consultNsus({ nsus, date }) {
        return this.fetch({
            url: 'veripag/installments/consult/nsu-date',
            data: {
                nsu: nsus,
                date,
            },
            method: methods.POST,
        });
    }

    updateStatus({ installmentsIds, status: saleStatusId, username }) {
        return this.fetch({
            method: methods.PUT,
            url: 'veripag/installments/update/status',
            data: {
                installmentsIds, saleStatusId, username,
            },
        });
    }

    getHistory({ page, limit }) {
        return this.fetch({
            url: '/veripag/installments/updated',
            params: {
                page, limit,
            },
        });
    }
}

export default new InstallmentsService();
